import zbmyAccount from './fs-account.vue'

export default zbmyAccount
